<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="solutionExplorePage">
            <div class="bannerArea">
                <div class="bannerBox">
                    <div class="wordBox">
                        <h1>{{ 'solutions.explore.title' | translate }}</h1>
                        <h2>
                            {{ 'solutions.explore.subtitle' | translate }}
                        </h2>
                    </div>
                </div>
            </div>

            <div
                class="exploreArea"
                id="exploreArea">
                <div class="exploreBox">
                    <div class="searchBox">
                        <h2>
                            {{ 'solutions.explore.search.successfully' | translate }}
                        </h2>
                        <div class="searchInputBox">
                            <span class="p-input-icon-left">
                                <i
                                    #searchBtn
                                    class="left-icon-cus pi pi-search"
                                    (click)="
                                        getSuccessByKeyword(kw.value, $event)
                                    "></i>
                                <input
                                    #kw
                                    type="text"
                                    pInputText
                                    [(ngModel)]="keywordRaw"
                                    [placeholder]="
                                        'solutions.explore.search.placeholder'
                                            | translate
                                    "
                                    (keypress)="
                                        $event.key === 'Enter'
                                            ? getSuccessByKeyword(
                                                  kw.value,
                                                  $event
                                              )
                                            : null
                                    " />

                                <i
                                    class="right-icon-cus pi pi-times-circle"
                                    (click)="keywordRaw = ''"></i>
                            </span>
                            <button
                                type="button"
                                class="p-button p-button-outlined"
                                (click)="getSuccessByKeyword(kw.value, $event)">
                                {{ 'solutions.explore.search.button' | translate }}
                            </button>
                        </div>
                        <div class="tagBox">
                            <ng-container *ngFor="let tag of recommendTags">
                                <span
                                    (click)="addTagToKeyword(tag)">
                                    {{
                                        'solutions.explore.search.recommendTags.' + tag
                                            | translate
                                    }}
                                </span>
                            </ng-container>
                        </div>
                    </div>
                    <div class="resultsBox">
                        <ng-container
                            *ngIf="successByKeyword.length; else noSuccess">
                            <div class="cardContainer">
                                <ng-container
                                    *ngFor="let result of successByPage">
                                    <div
                                        class="infoCard"
                                        [ngClass]="{
                                            'english-lang': isEnglish()
                                        }"
                                        (click)="goToSuccess(result?.NameEN)">
                                        <div class="vital">
                                            <p class="date">
                                                {{ result?.Date }}
                                            </p>
                                            <!-- <p class="type">
                                                {{
                                                    'solutions.explore.successCases.' +
                                                        getSolutionsKeyFromNameEN(
                                                            result?.NameEN
                                                        ) +
                                                        '.type' | translate
                                                }}
                                            </p> -->
                                            <h3 class="content">
                                                {{
                                                    'solutions.explore.successCases.' +
                                                        getSolutionsKeyFromNameEN(
                                                            result?.NameEN
                                                        ) +
                                                        '.name' | translate
                                                }}
                                            </h3>
                                            <div class="tagBox">
                                                <p>
                                                    {{
                                                        'solutions.explore.successCases.' +
                                                            getSolutionsKeyFromNameEN(
                                                                result?.NameEN
                                                            ) +
                                                            '.tags' | translate
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="paginationBox">
                                <p-paginator
                                    (onPageChange)="getDataByPage($event)"
                                    [first]="1"
                                    [rows]="6"
                                    [totalRecords]="successByKeyword.length"
                                    [showFirstLastIcon]="false"></p-paginator>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <app-partnership></app-partnership>
        </div>
    </div>
</div>
<app-footer></app-footer>

<ng-template #noSuccess>
    <div class="noResultBox">
        <p>{{ 'solutions.explore.search.noResult' | translate }}</p>
    </div>
</ng-template>
